import * as React from "react";
import Clock from "./ClockComponent"
import "../scss/header.scss"
import logo from "../img/OOEVV_Logo.png"
import webIcon from "../img/OOEVV_Web_Pikto.png"
import phoneIcon from "../img/OOEVV_Tel_Pikto.png"

export interface HeaderProps {

}

export class HeaderComponent extends React.Component<HeaderProps, {}> {
	public render() {
		return (

			<div className="header">
				<Clock />
				<div className="color-information-section">
					<div className="information-top-yellow">
						<span>Haltestellenaufenthalt</span>
					</div>
					<div className="information-middle-red-white">
						<span>bereits abgefahren</span>
					</div>
					<div className="information-bottom-white">
						<span>weitere Abfahrten</span>
					</div>
				</div>
				<div className="ooevv-info">
					<div className="web-adress-container">
						<img src={webIcon} alt=""></img>
						<span>www.ooevv.at</span>
					</div>
					<div className="phone-number-container">
						<img src={phoneIcon} alt=""></img>
						<span>+43 732 66 10 10 66</span>
					</div>
				</div>
				<div className="ooevv-logo-right">
					<div className="img-container">
						<img src={logo} alt=""></img>
					</div>
				</div>
			</div>
		);
	}
}

export default HeaderComponent;